import { graphql } from "gql.tada";

export const GET_CALCULATION_SUMMARIES = graphql(`
  query GetCalculationSummaries(
    $filter: CalculationFilterInput
    $page: Int!
    $size: Int!
  ) {
    calculationSummaries(filter: $filter, page: $page, size: $size) {
      content {
        id
        name
        kamName
        line
        supplierName
        planningYear
        status
        updatedAt
        categoryNames
      }
      totalElements
      totalPages
      page
      size
    }
  }
`);

export const GET_FILTER_OPTIONS = graphql(`
  query GetFilterOptions {
    kamNames
  }
`);

export const GET_REFERENCE_DATA = graphql(`
  query GetReferenceData {
    calculationCategoryDefinitions {
      id
      name
      displayOrder
      subCategories {
        id
        name
        displayOrder
        defaultDimensionTypeId
        defaultFormulaTemplateId
      }
    }
    dimensionTypes {
      id
      name
      values
    }
    suppliers {
      id
      name
    }
  }
`);
